import { defineStore } from "pinia";
import axios from "axios";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export const useReservationStore = defineStore("reservation", {
  state: () => ({
    reservations: [] as Array<{
      id?: number;
      name: string;
      message?: string;
      status: string;
    }>,
  }),
  actions: {
    async fetchReservations(side: string) {
      try {
        const res = await axios.get(`${API_BASE_URL}/${side}/reservasi`);
        // const res = await axios.get(`${API_BASE_URL}/`);
        this.reservations = res.data.data || res.data || [];
      } catch (error) {
        console.error("Gagal mengambil data reservasi:", error);
      }
    },
    getStatusIcon(status: string) {
      switch (status) {
        case "hadir":
          return ["fas", "check-circle"];
        case "tidak_hadir":
          return ["fas", "times-circle"];
        case "ragu":
        default:
          return ["fas", "question-circle"];
      }
    },
  },
});
